const cfg=JSON.parse(document.getElementById('cc-buy-config').textContent);
const storageKey='cc-recent-products-v1';
const normal=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
function kind(title){const n=normal(title);let key='';if(/carcasa|housing/.test(n))key='case';else if(/goma|tecla/.test(n))key='rubber';else if(/programador|programadora/.test(n))key='programmer';else if(/maquina|duplicadora/.test(n))key='machine';else if(/solo chip/.test(n))key='chip';else if(/bateria|pilas|pila \//.test(n))key='battery';else if(/llave control|remoto|control remoto/.test(n))key='remote';else if(/forja|llave hueca|llave con chip/.test(n))key='blade';return cfg.kindLabels[key]||'';}
window.ccProductKind=kind;
const make=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;};
class ProductFacts extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const list = this.querySelector('[data-cc-facts]');
    if (!list) return;
    for (const row of list.querySelectorAll('[data-cc-derived]')) row.remove();
    const title = this.dataset.title || '';
    const add = (label, values) => {
      const value = [...new Set(values)].join(' / ');
      if (!value) return;
      const row = make('div');
      row.dataset.ccDerived = '';
      row.append(make('dt', '', label), make('dd', '', value));
      list.append(row);
    };
    add(cfg.frequency, [...title.matchAll(/\b\d{2,4}(?:[.,]\d+)?\s*MHZ\b/gi)].map(m => m[0]));
    add(cfg.buttons, [...title.matchAll(/\b([1-9])\s*(?:B|BOTONES?)\b/gi)].map(m => m[1]));
    add(cfg.chip, [...title.matchAll(/\b(?:ID\s*\d{2,3}[A-Z]?|4[CD]\d{2}(?:\+\d{2})?|TP\d{1,3})\b/gi)].map(m => m[0]));
    add(cfg.reference, [...title.matchAll(/\b(?:OHT|OUC|HYQ|CWT|KR5|M3N|NBG|YGO)[A-Z0-9-]{4,}\b/gi)].map(m => m[0]));
    list.hidden = !list.childElementCount;
    this.closest('.shopify-section')?.addEventListener('variant:update', event => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const variant = event.detail.resource;
      const row = list.querySelector('[data-cc-sku]');
      if (row) {
        row.querySelector('dd').textContent = variant?.sku || '';
        row.hidden = !variant?.sku;
      }
      list.hidden = ![...list.children].some(item => !item.hidden);
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('cc-product-facts')) customElements.define('cc-product-facts', ProductFacts);
function read(){try{const data=JSON.parse(localStorage.getItem(storageKey));return Array.isArray(data)?data.filter(x=>typeof x==='string'&&/^[a-z0-9-]+$/.test(x)).slice(0,12):[];}catch{return [];}}
let previous=read();
if(cfg.current){try{localStorage.setItem(storageKey,JSON.stringify([cfg.current,...previous.filter(x=>x!==cfg.current)].slice(0,12)));}catch{}}
class RecentProducts extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.cleared = false;
    this.querySelector('[data-cc-clear]')?.addEventListener('click', () => {
      this.cleared = true;
      this.controller.abort();
      this.observer?.disconnect();
      try { localStorage.removeItem(storageKey); } catch {}
      this.hidden = true;
      this.querySelector('[data-cc-recent-list]').replaceChildren();
    }, { signal: this.controller.signal });
    const handles = read().filter(x => x !== cfg.current).slice(0, 6);
    if (!handles.length) return;
    this.hidden = false;
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(e => e.isIntersecting)) return;
      this.observer.disconnect();
      this.load(handles);
    }, { rootMargin: '300px' });
    this.observer.observe(this);
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
  async load(handles) {
    const list = this.querySelector('[data-cc-recent-list]');
    const root = cfg.root.replace(/\/?$/, '/');
    const money = new Intl.NumberFormat(cfg.currency === 'MXN' ? 'es-MX' : cfg.locale, { style: 'currency', currency: cfg.currency });
    const signal = this.controller.signal;
    const results = await Promise.allSettled(handles.map(async handle => {
      const res = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { signal });
      if (!res.ok) return null;
      return res.json();
    }));
    if (signal.aborted || this.cleared || !this.isConnected) return;
    list.replaceChildren();
    for (const result of results) {
      if (result.status !== 'fulfilled' || !result.value) continue;
      const p = result.value;
      const a = make('a', 'cc-recent-card');
      a.href = root + 'products/' + encodeURIComponent(p.handle);
      if (p.featured_image) {
        const img = make('img');
        const url = new URL(p.featured_image, location.origin);
        url.searchParams.set('width', '360');
        img.src = url.href;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 180;
        img.height = 180;
        a.append(img);
      }
      const label = kind(p.title);
      if (label) a.append(make('span', 'cc-kind', label));
      a.append(make('strong', '', p.title));
      if (p.variants?.[0]?.sku) a.append(make('small', '', cfg.sku + ': ' + p.variants[0].sku));
      a.append(make('span', 'cc-recent-price', money.format(p.price / 100)));
      if (!p.available) a.append(make('small', '', cfg.soldOut));
      list.append(a);
    }
    this.hidden = !list.childElementCount;
  }
}
if (!customElements.get('cc-recent-products')) customElements.define('cc-recent-products', RecentProducts);
const returnKey = 'cc-shopping-return';
const restoreKey = 'cc-restore-scroll';
const currentUrl = () => location.pathname + location.search;
const cartPath = cfg.root.replace(/\/?$/, '/') + 'cart';
const shoppingPage = () => location.pathname !== cartPath && !location.pathname.startsWith('/checkouts');
const safeReturn = item => {
  if (!item || typeof item.url !== 'string' || !item.url.startsWith('/')) return false;
  try {
    const url = new URL(item.url, location.origin);
    return url.origin === location.origin && url.pathname !== cartPath && !url.pathname.startsWith('/checkouts');
  } catch { return false; }
};
const saveReturn = () => {
  if (!shoppingPage()) return;
  try { sessionStorage.setItem(returnKey, JSON.stringify({ url: currentUrl(), y: scrollY })); } catch {}
};
let restoring = false;
try {
  const item = JSON.parse(sessionStorage.getItem(restoreKey));
  if (safeReturn(item) && item.url === currentUrl()) {
    restoring = true;
    sessionStorage.removeItem(restoreKey);
    const restore = () => requestAnimationFrame(() => requestAnimationFrame(() => {
      scrollTo({ top: Math.max(0, Number(item.y) || 0), behavior: 'instant' });
      restoring = false;
      saveReturn();
    }));
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore, { once: true });
  }
} catch {}
if (shoppingPage()) {
  if (!restoring) saveReturn();
  let timer;
  document.addEventListener('scroll', () => {
    if (restoring || document.querySelector('dialog[open][scroll-lock]')) return;
    clearTimeout(timer);
    timer = setTimeout(saveReturn, 160);
  }, { passive: true });
  window.addEventListener('pagehide', saveReturn);
}
for (const link of document.querySelectorAll('[data-cc-return]')) {
  try {
    const item = JSON.parse(sessionStorage.getItem(returnKey));
    if (safeReturn(item)) link.href = item.url;
  } catch {}
}
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-cc-return]');
  if (link) {
    try {
      const item = JSON.parse(sessionStorage.getItem(returnKey));
      if (safeReturn(item)) {
        link.href = item.url;
        sessionStorage.setItem(restoreKey, JSON.stringify(item));
      }
    } catch {}
    return;
  }
  const cartLink = event.target.closest('a[href], [data-testid="cart-drawer-trigger"]');
  if (!cartLink) return;
  if (cartLink.matches('[data-testid="cart-drawer-trigger"]') || new URL(cartLink.href, location.origin).pathname === cartPath) saveReturn();
}, true);
